import React, { Component } from 'react';
import axios from 'axios'
import Cookies from 'universal-cookie';
import { CSVLink } from "react-csv"
import dayjs from 'dayjs';
import '../App.css';

import SuppliesTableEx from '../controls/SuppliesTableEx'
import LoadingControl from '../controls/Loading';
import DownloadButton from '../controls/DownloadButton';
import PercentInput from '../controls/PercentInput'
import {objectWitOnlyProperties, DeviceStatusToString, getCurrentSupplyLevel} from '../utils/utils'

const limitCookieName = 'suppliesLimit';

const cookies = new Cookies();

class SuppliesPane extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoaded: false,
      items: null,
      csvData: [],
      minimal_level: cookies.get(limitCookieName) || 100
    };
  }
  
  async getData(limit_value) {
    let maxDate = new Date();
    
    var url = "/printer?sort=prnName&start=1&end=" + Math.round(maxDate.getTime() / 1000);
    
    url += "&supplyLimit=" + limit_value;

    const res = await axios(url);
    return res.data;
  }

  update(limit_value) {
    this.setState({isLoaded: false});

    this.getData(limit_value)
    .then(res => {
      this.setState({ error: null, isLoaded: true, items: res, minimal_level: limit_value });
    })
    .catch(err => {
      console.log(err);
      this.setState( {error: err, isLoaded: false, items: null });
    });
  }  
  
  componentDidMount() {
    this.update(this.state.minimal_level);
  }

  getCVSData()
  {
      var raw_data = this.state.items;
      var sorted_data = [];                
      var propertiesDevice = ["prnName", "prnComment", "prnLocation", "status", "model", "ip", "pagesCount", "serialNumber", "supplies"];
      
      for (var i = 0; i < raw_data.length; i++)
      {
          var device = objectWitOnlyProperties(raw_data[i], propertiesDevice);

          device["status"] = DeviceStatusToString(device["status"]);

          if (device.supplies !== undefined)
          {
              for (var j = 0; j < device.supplies.length; j++)
              {
                  var value = {
                      level : device.supplies[j].level,
                      maxCapacity : device.supplies[j].maxCapacity,
                      color : device.supplies[j].color
                  };

                  var result = getCurrentSupplyLevel(value);

                  var supply = {
                      description: device.supplies[j].description,
                      currentLevel : result.current_level,
                      changeDate : dayjs(device.supplies[j].changeDate).format('LL'),
                      changePagesCount : device.supplies[j].changePagesCount,
                      nextChangeDate : dayjs(device.supplies[j].nextChangeDate).format('LL'),
                      remainPages : device.supplies[j].remainPages
                  }
                  sorted_data.push(Object.assign({}, device, supply));
              }
          }
          else
          {
              var empty_supply = {
                  description: "",
                  currentLevel : "",
                  changeDate : "",
                  changePagesCount : "",
                  nextChangeDate : "",
                  remainPages : ""
              }
              sorted_data.push(Object.assign({}, device, empty_supply));
          }
      }

      sorted_data.map(item => {delete item.supplies; return item;});

      return sorted_data;
  }

  onCSVExportClick()
  {
    var sortedData = this.getCVSData();
    this.setState({ csvData: sortedData }, () => {
      // click the CSVLink component to trigger the CSV download
      this.csvLink.link.click()}
    );
  }

  onLevelUpdate(value) {
    this.update(value);

    cookies.set(limitCookieName, value, {maxAge: 60 * 60 * 24 * 30});
  }

    render() {
      if(this.state.error != null)
      {
        return (
          <div><h3>{this.state.error.message}</h3></div>
        );
      }
      else if (!this.state.isLoaded)
      {
        return (
          <div><LoadingControl/></div>
        );
      }
      else
      {
        return (
          <div>
            <div className = "history-pane-header">
              <PercentInput onUpdate = {(value) => this.onLevelUpdate(value)} minimalLevel = {this.state.minimal_level}/>
              <CSVLink 
                data={this.state.csvData}
                separator=";"
                ref={(r) => this.csvLink = r}
                filename="devices_supplies.csv"
                className="hidden"
                target="_blank">                
                </CSVLink>
              <DownloadButton onCSVExport = {() => {this.onCSVExportClick()}}/>
              <SuppliesTableEx data = {this.state.items} />
              </div>
          </div>  
        );
      }
  }
}

export default SuppliesPane;